import script from "./caidan.vue?vue&type=script&setup=true&lang=ts"
export * from "./caidan.vue?vue&type=script&setup=true&lang=ts"

import "./caidan.vue?vue&type=style&index=0&id=acc88806&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acc88806"]])

export default __exports__